<template>
  <div>
    <v-layout
      row
      wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="headline">Ativar Cupom</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-layout
                row
                wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="codigo"
                    label="Insira o código do cupom para ativação"
                    append-icon="mdi-save"
                    single-line
                    hide-details
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="primary"
              dark
              @click="ativarCupom">Ativar</v-btn>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  name: 'AtivarCupom',
  data () {
    return {
      codigo: ''
    }
  },
  methods: {
    ativarCupom () {
      if (this.codigo.length > 0) {
        this.$store.dispatch('ativarCupom', { codigo: this.codigo }).then(r => {
          
          if (r.data === false) {
            alert('Cupom inválido!')
          } else {
            alert('Cupom ativado com sucesso!')
          }
        })
        this.codigo = ''
        this.$store.dispatch('getCupons')
      }
    }
  }
}
</script>
